import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel, createStyles, Theme as AugmentedTheme, TextField} from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { ArticleFieldEditComponent } from './ArticleComponent';

interface IArticle {
    field: CustomInputMappingField,
    value: string,
    isRtl: boolean
    onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void,
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    title: {
        marginTop: 16,
        marginLeft: 16,
        fontFamily: 'Arial',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: 16,
        lineHeight: '24px',
        letterSpacing: 0.147638,
        color: '#0C0C0D',
    },
    body: {
        position: 'relative',
        margin: 16,
        height: 160
    } as CSSProperties,
    actions: {

    },
    paper: {
        width: 447,
        maxWidth: 447
    },
    draw: {
        width: 415,
        height: 160,
        background: '#FFFFFF',
        border: '1px solid #D7D7DB',
        borderRadius: 4,
        marginRight: 'auto', 
        marginLeft: 'auto'
    },
    clear: {
        top: 8,
        right: 8,
        position: 'absolute',
        cursor: 'pointer',
    } as CSSProperties,
    img: {
        marginTop: 12,
        boxSizing: 'border-box',
        width: 270,
        height: 104,
        background: '#FFFFFF',
        border: '1px solid #D7D7DB',
        borderRadius: 4,
    },
    hiddenReq: {
        height: 1,
        width: 1,
        position: 'absolute',
        left: '14%',
        top: '40%',    
        display: 'flex',
        opacity: 0,
    },
    field: {
        width: '100%',
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '.2px',
        lineHeight: '20px',
        color: '#202124',

        "&::placeholder": {
            fontSize: '14px',
        },
    },
      //@ts-ignore
      inputLabel: theme.inputLabel,
      //@ts-ignore
      requiredLabel: theme.requiredLabel,
}))

function ArticleField({ field, value, onChangeHandler, isRtl }: IArticle) {
    const classes = useStyles();

    const afterSave = (str: string) => {
        onChangeHandler?.({ currentTarget: {value: str} } as React.ChangeEvent<HTMLInputElement>)
    }

    const isEmpty = !value || value.trim() === ''
    const showRequired = field.required && isEmpty
    const Req =  field.required && (!value) ? <TextField className={classes.hiddenReq} required style={{}} /> : null

    const Input = <ArticleFieldEditComponent
        editMode
        denyAutofocus
        value={value}
        onBlur={() => {}}
        onChange={afterSave}
    />

    const Value =      <>
        <InputLabel
    style={{ 
        direction: isRtl ? 'rtl' : 'ltr',
        textAlign: isRtl ? 'right' : 'left' 
    }} 
    htmlFor={field.sourceField} 
    className={showRequired ? classes.requiredLabel : classes.inputLabel}
    >{field.fieldName}</InputLabel>
    {Req}
    {Input}
    </>

    return (
        <div style={{position: 'relative',}}>
            {Value}
        </div>
    )
}

export default memo(ArticleField, (prev: IArticle, next: IArticle) => prev.value === next.value)